import { getToken } from "./AsyncSetup";

export const apiBaseURL = "https://admin.cineflixtheater.com/api/v1";
const X_API_KEY = "kBehUoUlzPPKKyLlm4DJiE5FRUMTM6GayiZOgZUw";

const appendFormData = (formData, key, value) => {
  if (Array.isArray(value)) {
    value.forEach((item) => {
      formData.append(`${key}[]`, item);
    });
    return;
  }

  formData.append(key, value);
};

export const loginUser = async (email_phone, password) => {
  const response = await fetch(`${apiBaseURL}/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      "Accept": "application/json",
    },
    body: JSON.stringify({ email_phone, password }),
  });

  const data = await response.json();
  return data;
};

export const GetApiHandler = async (params, endPoint) => {
  // Create query string from params
  const queryString = new URLSearchParams(params)?.toString();

  // Fetch data with GET request
  const response = await fetch(`${apiBaseURL}/${endPoint}?${queryString}`, {
    method: 'GET',
    headers: {
      "Authorization": `Bearer ${ await getToken()}`,
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-API-KEY": X_API_KEY,
    },
  });

  // Check if the response is successful
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  // Parse JSON response
  const data = await response.json();
  return data;
};


export const PostApiHandler = async (obj,endPoint) => {
  const response = await fetch(`${apiBaseURL}/${endPoint}`, {
    method: 'POST',
    headers: {
      // "Authorization": `Bearer ${ await getToken()}`,
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-API-KEY": X_API_KEY,
    },
    body: JSON.stringify(obj),
  });
  const data = await response.json();
  return data;
};

export const PostApiHandlerforFilesUpload = async (obj, endPoint) => {
  const hasFile = Object.values(obj).some(value => value instanceof File);

  let body;
  let headers = {
    "Accept": "application/json",
    "X-API-KEY": X_API_KEY,
  };

  if (hasFile) {
    body = new FormData();
    for (const key in obj) {
      appendFormData(body, key, obj[key]);
    }
  } else {
    headers["Content-Type"] = "application/json";
    body = JSON.stringify(obj);
  }

  const response = await fetch(`${apiBaseURL}/${endPoint}`, {
    method: 'POST',
    headers,
    body,
  });
  
  const data = await response.json();
  return data;
};

export const PostApiHandlerforFilesUploadWithToken = async (obj, endPoint) => {
  const token = await getToken(); // Ensure getToken returns the token
  const hasFile = Object.values(obj).some(value => value instanceof File);

  let body;
  // Add the token to the headers
  let headers = {
    "Accept": "application/json",
    "Authorization": `Bearer ${token}`,
    "X-API-KEY": X_API_KEY,
  };

  if (hasFile) {
    body = new FormData();
    for (const key in obj) {
      appendFormData(body, key, obj[key]);
    }
  } else {
    headers["Content-Type"] = "application/json";
    body = JSON.stringify(obj);
  }

  const response = await fetch(`${apiBaseURL}/${endPoint}`, {
    method: 'POST',
    headers,
    body,
  });
  
  const data = await response.json();
  return data;
};





export const PostApiHandlerwithToken = async (obj,endPoint) => {
  const response = await fetch(`${apiBaseURL}/${endPoint}`, {
    method: 'POST',
    headers: {
      "Authorization": `Bearer ${ await getToken()}`,
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-API-KEY": X_API_KEY,
    },
    body: JSON.stringify(obj),
  });
  const data = await response.json();
  return data;
};


export const PostApiHandlerMultipart = async (obj, endPoint) => {
  const formData = new FormData();

  // Append all fields to FormData
  for (const key in obj) {
      if (obj[key]) {
          if (typeof obj[key] === 'object' && obj[key].uri) {
              // Append file fields
              formData.append(key, {
                  uri: obj[key].uri,
                  name: obj[key].name || `${key}.jpg`,
                  type: obj[key].type || 'image/jpeg',
              });
          } else {
              // Append regular fields
              formData.append(key, obj[key]);
          }
      }
  }

  // Perform the API call
  const response = await fetch(`${apiBaseURL}/${endPoint}`, {
      method: 'POST',
      headers: {
          "Authorization": `Bearer ${await getToken()}`, // Add token to the headers
          "Accept": "application/json", // Accept JSON response
          "X-API-KEY": X_API_KEY,
      },
      body: formData,
  });

  const data = await response.json();
  return data;
};


export const RegisterPostApiHandlerMultipart = async (endPoint, formData) => {
  console.log('API Endpoint:', `${apiBaseURL}/${endPoint}`);
  
  try {
    const response = await fetch(`${apiBaseURL}/${endPoint}`, {
      method: 'POST',
      headers: {
        "Authorization": `Bearer ${await getToken()}`,
        "Accept": "application/json",
        "X-API-KEY": X_API_KEY,
      },
      body: formData,
    });

    const data = await response.json();
    console.log('API Response:', data);
    return data;
  } catch (error) {
    console.error('API Call Error:', error);
    throw error;
  }
};
